import { render, staticRenderFns } from "./ReleaseView.vue?vue&type=template&id=719f95c2&"
import script from "./ReleaseView.vue?vue&type=script&lang=js&"
export * from "./ReleaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports